import PackagesTable from './PackagesTable';

export default PackagesTable;



// WEBPACK FOOTER //
// ./src/components/molecules/PackagesTable/index.js